export default "__VITE_ASSET__D7n0LGzt__"